<button (click)="onClick($event)">
  <ng-content></ng-content>
</button>
